import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2, MapPin, X } from 'lucide-react';
type Sale = {
  name: string;
  city: string;
  ago: string;
};
// Compradores de todas partes de Argentina
const SALES: Sale[] = [{
  name: 'María',
  city: 'Rosario, Santa Fe',
  ago: 'hace 2 minutos'
}, {
  name: 'Jorge',
  city: 'Córdoba Capital',
  ago: 'hace 5 minutos'
}, {
  name: 'Silvia',
  city: 'La Plata, Buenos Aires',
  ago: 'hace 1 minuto'
}, {
  name: 'Roberto',
  city: 'Mendoza',
  ago: 'hace 8 minutos'
}, {
  name: 'Patricia',
  city: 'Mar del Plata',
  ago: 'hace 3 minutos'
}, {
  name: 'Héctor',
  city: 'San Miguel de Tucumán',
  ago: 'hace 6 minutos'
}, {
  name: 'Norma',
  city: 'Salta',
  ago: 'hace 4 minutos'
}, {
  name: 'Daniel',
  city: 'Neuquén',
  ago: 'hace 7 minutos'
}, {
  name: 'Graciela',
  city: 'Posadas, Misiones',
  ago: 'hace 2 minutos'
}, {
  name: 'Carlos',
  city: 'San Juan',
  ago: 'hace 9 minutos'
}, {
  name: 'Liliana',
  city: 'Resistencia, Chaco',
  ago: 'hace 1 minuto'
}, {
  name: 'Alberto',
  city: 'Bahía Blanca',
  ago: 'hace 5 minutos'
}, {
  name: 'Mónica',
  city: 'Santiago del Estero',
  ago: 'hace 3 minutos'
}, {
  name: 'Eduardo',
  city: 'Corrientes',
  ago: 'hace 6 minutos'
}, {
  name: 'Susana',
  city: 'Comodoro Rivadavia',
  ago: 'hace 4 minutos'
}, {
  name: 'Raúl',
  city: 'San Salvador de Jujuy',
  ago: 'hace 8 minutos'
}];
export function SalesPopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let hideTimeout: ReturnType<typeof setTimeout>;
    // First popup after 6s
    const firstShow = setTimeout(() => setVisible(true), 6000);
    // Cycle every 15 seconds
    const interval = setInterval(() => {
      setIndex(prev => (prev + 1) % SALES.length);
      setVisible(true);
      hideTimeout = setTimeout(() => setVisible(false), 6000);
    }, 15000);
    // Hide the first one too
    const firstHide = setTimeout(() => setVisible(false), 12000);
    return () => {
      clearTimeout(firstShow);
      clearTimeout(firstHide);
      clearTimeout(hideTimeout);
      clearInterval(interval);
    };
  }, []);
  const sale = SALES[index];
  return <div className="fixed bottom-4 left-4 z-50 max-w-[calc(100vw-2rem)]" data-id="element-210">
      <AnimatePresence data-id="element-211">
        {visible && <motion.div key={index} initial={{
        opacity: 0,
        y: 24,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 24,
        scale: 0.95
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 26
      }} className="flex items-center gap-3 bg-white rounded-2xl shadow-xl border border-slate-200 pl-3 pr-4 py-3 w-80 max-w-full" role="status" aria-live="polite" data-id="element-212">
            <div className="shrink-0 w-10 h-10 rounded-full bg-green-100 text-green-600 flex items-center justify-center" data-id="element-213">
              <CheckCircle2 size={22} data-id="element-214" />
            </div>
            <div className="min-w-0" data-id="element-215">
              <p className="text-sm font-bold text-slate-900 leading-tight" data-id="element-216">
                {sale.name} acaba de comprar
              </p>
              <p className="text-xs text-slate-500 flex items-center gap-1 mt-0.5" data-id="element-217">
                <MapPin size={12} className="text-blue-500 shrink-0" data-id="element-218" />
                <span className="truncate" data-id="element-219">{sale.city}</span>
                <span className="text-slate-300" data-id="element-220">·</span>
                <span className="whitespace-nowrap" data-id="element-221">{sale.ago}</span>
              </p>
            </div>
            <button onClick={() => setVisible(false)} aria-label="Cerrar notificación" className="shrink-0 text-slate-400 hover:text-slate-600 transition-colors" data-id="element-222">
              <X size={16} data-id="element-223" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}